(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["foundation-editorial"] && !Shopify.designMode) return;
  try {
    (() => {
  const arrange = () => {
    if (!document.querySelector('.mi-livia-product')) return;
    const faq = document.querySelector('[id$="__faq_metafields_kkjBcp"]');
    const reviews = document.querySelector('[id$="__17606872297681e587"]');
    if (faq && reviews) faq.before(reviews);
    const product = document.querySelector('.mi-livia-product');
    const sticky = product.querySelector('.product-sticky-add-to-cart');
    const button = product.querySelector('.product-add-to-cart > button[type="submit"]');
    if (sticky && button && !product.dataset.liviaStickyReady) {
      product.dataset.liviaStickyReady = 'true';
      const update = () => sticky.classList.toggle('mi-livia-sticky-visible', button.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange, { once: true });
  else arrange();
  document.addEventListener('shopify:section:load', arrange);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["livia-editorial"] && !Shopify.designMode) return;
  try {
    (() => {
  const arrange = () => {
    if (!document.querySelector('.mi-livia-product')) return;
    const faq = document.querySelector('[id$="__faq_metafields_kkjBcp"]');
    const reviews = document.querySelector('[id$="__17606872297681e587"]');
    if (faq && reviews) faq.before(reviews);
    const product = document.querySelector('.mi-livia-product');
    const sticky = product.querySelector('.product-sticky-add-to-cart');
    const button = product.querySelector('.product-add-to-cart > button[type="submit"]');
    if (sticky && button && !product.dataset.liviaStickyReady) {
      product.dataset.liviaStickyReady = 'true';
      const update = () => sticky.classList.toggle('mi-livia-sticky-visible', button.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange, { once: true });
  else arrange();
  document.addEventListener('shopify:section:load', arrange);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mineralissima-collection-editorial"] && !Shopify.designMode) return;
  try {
    (() => {
  const formatEditorial = (scope) => {
    scope.querySelectorAll('.collection__grid--seo-wrapper, .mtc-seo').forEach((wrapper) => {
      const content = wrapper.querySelector('.metafield-rich_text_field') || wrapper.querySelector('.collection__grid--seo-description');
      if (!content || content.classList.contains('mc-seo-editorial')) return;
      const nodes = Array.from(content.childNodes);
      const headings = nodes.filter((node) => node.nodeType === 1 && /^H[2-4]$/.test(node.tagName));
      if (!headings.length) return;
      const fragment = document.createDocumentFragment();
      let index = 0;
      while (index < nodes.length) {
        const node = nodes[index];
        if (node.nodeType !== 1 || !/^H[2-4]$/.test(node.tagName)) {
          fragment.append(node);
          index += 1;
          continue;
        }
        const following = [];
        index += 1;
        while (index < nodes.length && !(nodes[index].nodeType === 1 && /^H[2-4]$/.test(nodes[index].tagName))) {
          following.push(nodes[index]);
          index += 1;
        }
        const hasBody = following.some((item) => item.nodeType === 1 || (item.nodeType === 3 && item.textContent.trim()));
        const isIntro = node === headings[0] && node.tagName === 'H2';
        if (!hasBody || isIntro) {
          node.classList.add('mc-seo-section-heading');
          fragment.append(node, ...following);
        } else {
          const row = document.createElement('div');
          const body = document.createElement('div');
          row.className = 'mc-seo-row';
          body.className = 'mc-seo-body';
          body.append(...following);
          row.append(node, body);
          fragment.append(row);
        }
      }
      content.append(fragment);
      content.classList.add('mc-seo-editorial');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => formatEditorial(document), { once: true });
  } else {
    formatEditorial(document);
  }
  document.addEventListener('shopify:section:load', (event) => formatEditorial(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mlf-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const ready = () => document.querySelectorAll('.mlf-collection .mc-sort').forEach(form => form.classList.add('mlf-sort-ready'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', ready);
  document.addEventListener('change', event => {
    const select = event.target.closest('.mlf-collection .mc-sort select');
    if (select) select.form.requestSubmit();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["primer-editorial"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const panel = document.querySelector('.mi-primer-product');
    if (!panel || panel.dataset.primerStickyReady) return;
    const sticky = panel.querySelector('.product-sticky-add-to-cart');
    const button = panel.querySelector('.product-add-to-cart > button[type="submit"]');
    if (!sticky || !button) return;
    panel.dataset.primerStickyReady = 'true';
    const update = () => sticky.classList.toggle('mi-livia-sticky-visible', button.getBoundingClientRect().bottom < 0);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

})();
